import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { Variable } from '../model/models'

export class VariableAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getVariables = this.getVariables.bind(this)
    this.initVariables = this.initVariables.bind(this)
  }

  public getVariables(): Promise<Variable[]> {
    const endpoint = `/variables`
    return this.get<Variable[]>(endpoint)
      .then((response: AxiosResponse<Variable[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public initVariables(): Promise<number> {
    const endpoint = `/configuration/variables/initialize`
    return this.post(endpoint, {})
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }
}

export const variableAPI = new VariableAPI(httpConfig)
